import service from "../plugins/axios";

// 实时查询汇总接口
export function realtimeQueryCount(data) {
	return new Promise((resolve, reject) => {
		service
			.post("/basicinfo/realtimeQueryCount", data)
			.then((res) => {
				if (res && res.code === 200) {
					resolve(res);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
}
// 实时查询列表接口
export function realtimeQueryList(data) {
	return new Promise((resolve, reject) => {
		service
			.post("/basicinfo/realtimeQueryList", data)
			.then((res) => {
				if (res && res.code === 200) {
					resolve(res);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
}
// T+1查询接口
export function t1QueryCount(data) {
	return new Promise((resolve, reject) => {
		service
			.post("/basicinfo/t1QueryCount", data)
			.then((res) => {
				if (res && res.code === 200) {
					resolve(res);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
}
// 认证接口
export function getAuth(data) {
	return new Promise((resolve, reject) => {
		service
			.post("/auth/third", data)
			.then((res) => {
				if (res && res.code === 200) {
					resolve(res);
				} else {
					reject("登录失败，请检查账号密码");
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
}
